<template>
  <div class="embed view">
    <!-- {{ dataCard }}  -->
    <injected-chart
      :config="{url: $route.fullPath, kpis: []}"
      :title="true"
      :visible="true"
      :blank="true"
    />
  </div>
</template>

<script>
// import { getItemById } from '@/services/api'
// import { getStatisticsTable } from '@/services/table-api'
import InjectedChart from '../components/charts/InjectedChart.vue'
export default {
  components:{InjectedChart},
  props: {
    // /**
    //  * Id of printed card
    //  */
    // cardId: {
    //   type: String,
    // },
    // /**
    //  * Source type of the item
    //  */
    // type: {
    //   type: String,
    // },
  },
  computed:{
    // pivotConfig(){
    //   return {}
    // },
    // sourceToApi() {
    //   if (this.$getTypesOfContent?.data?.length !== 0) {
    //     if (
    //       this.$getTypesOfContent.data.find(el => el.type === 'MICRODATA') &&
    //       this.type ===
    //         this.$getTypesOfContent.data.find(el => el.type === 'MICRODATA').label[this.currentLang]
    //     )
    //       return 'microdata'
    //     else if (
    //       this.$getTypesOfContent.data.find(el => el.type === 'STATISTICS') &&
    //       this.type ===
    //         this.$getTypesOfContent.data.find(el => el.type === 'STATISTICS').label[
    //           this.currentLang
    //         ]
    //     )
    //       return 'statistic'
    //     else if (
    //       this.$getTypesOfContent.data.find(el => el.type === 'SURVEY') &&
    //       this.type ===
    //         this.$getTypesOfContent.data.find(el => el.type === 'SURVEY').label[this.currentLang]
    //     )
    //       return 'survey'
    //     else if (
    //       this.$getTypesOfContent.data.find(el => el.type === 'DOCS') &&
    //       this.type ===
    //         this.$getTypesOfContent.data.find(el => el.type === 'DOCS').label[this.currentLang]
    //     )
    //       return 'document'
    //     else if (
    //       this.$getTypesOfContent.data.find(el => el.type === 'MAPS') &&
    //       this.type ===
    //         this.$getTypesOfContent.data.find(el => el.type === 'MAPS').label[this.currentLang]
    //     )
    //       return 'map'
    //     else if (
    //       this.$getTypesOfContent.data.find(el => el.type === 'DATASTORIES') &&
    //       this.type ===
    //         this.$getTypesOfContent.data.find(el => el.type === 'DATASTORIES').label[
    //           this.currentLang
    //         ]
    //     )
    //       return 'datastory'
    //     else return 'item'
    //   } else return 'item'
    // },
  },
  asyncComputed: {
    // dataCard() {
    //   //using asyncCount to reload data
    //   return getItemById(this.cardId, this.currentLang, 'statistic')
    // },
    // contentData() {
    //   if (this.dataCard?.values) {
    //     return getStatisticsTable(this.dataCard)
    //   } else return null
    // },
  },
}
</script>

<style lang="stylus" scoped>
.embed
  width 100vw
  height 100vh
  .injected-chart
    // max-width 700px
    // max-height 500px
    min-width 200px
    min-height 100px
    width 100%
    height 100%
    margin auto
</style>
